import { White } from '@constants/color';
import { css } from '@emotion/react';

// TODO: move to global style
export const mainContainer = css({
  display: 'flex'
});

// TODO: move to global style
export const navContainer = css({
  position: 'fixed',
  height: '1080px',
  opacity: 0.8,
  zIndex: 5
});

// TODO: move to global style
// TODO: split into nav exists or not
export const contentContainer = css({
  marginLeft: '92px',
  padding: '64px',
  width: '1920px',
  height: '952px'
});
// TODO: move to global style
export const contentTopContainer = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: '120px',
  paddingRight: '40px'
});

export const refreshButton = css({
  padding: '0px',
  width: '120px',
  height: '48px',
  fontSize: '20px',
  color: White.White10,
  backgroundColor: White.White10Alpha15
});

// TODO: move to global style
export const title = css({
  color: White.White10,
  fontSize: '48px',
  fontWeight: 700
});
